import { useEffect, useState } from 'react'
import SectionForm, { getFormField, useFormContext } from "../SectionForm"
import { useBienContext } from '../BienContext'

const FieldList = [
  // Partie 1
  {name: "prm_linky", label: "PRM Linky"},
  {name: "numero_compteur_eau", label: "N° compteur d'eau"},
  {name: "numero_compteur_gaz", label: "N° compteur gaz"},
  // Partie 2
  {name: "loc_linky_commun", label: "Localisation Linky"},
  {name: "loc_compteur_eau", label: "Localisation compteur d'eau"},
  {name: "loc_compteur_gaz", label: "Localisation compteur gaz", only: ["maison", "appartement", "autre"]},
  // Partie 3
  {name: "numero_bac_poubelle", label: "N° Bac Poubelle", type: "text"},
  {name: "numero_badge_poubelle", label: "N° Badge Poubelle", type: "text"},
  {name: "numero_boitier_fibre", label: "N° Boîtier Fibre", type: "text"},
  { name: "detail_compteurs", label: "Détail des compteurs", type: "textarea",
    only: 'immeuble'
  }
]

const FormContent = ({fields, typeBien}) => {
  const { control } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-center gap-4 form-w-full-inputs"> 
        {fields.slice(0,3).map( (field, index) => getFormField(control, field, index))}
      </div>
      <div className="flex flex-col items-center gap-4 form-w-full-inputs"> 
        {fields.slice(3,6).map( (field, index) => getFormField(control, field, index))}
      </div>
      <div className="flex flex-col items-center gap-4 form-w-full-inputs">  
        { fields.slice(6,9).map( (field, index) => getFormField(control, field, index)) }
        {typeBien === 'immeuble' && (
            fields.slice(9).map( 
              (field,index) => getFormField(control,field,index)
            )
        )}
      </div>
    </>
  )
}

export default ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  const { bien } = useBienContext()
  const typeBien = bien.type_bien
  const [fields, setFields] = useState(FieldList)

  useEffect(
    () => {
      if(typeBien !== 'immeuble') {
        setFields(FieldList.filter( f => f.only !== 'immeuble' ))
      }
    },
    [typeBien]
  )
  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={[...fields.map( f => f.name)]}
    >
      <FormContent fields={fields} typeBien={typeBien}/>
    </SectionForm>
  )
}